define((require) => {
    "use strict";

    var $                              = require("jquery"),
        _                              = require("underscore"),
        EditBehavior                   = require("ui/behaviors/EditBehavior"),
        EditorEvents                   = require("shared/services/EditorEvents"),
        ImprovedView                   = require("editor/zbone/ImprovedView"),
        LoggedInUserState              = require("shared/ui/user/LoggedInUserState"),
        Promise                        = require("shared/util/Promise"),
        QuickViewExperienceDetailsView = require("ui/experienceOverview/QuickViewExperienceDetailsView"),
        QuickViewGroupDetailsView      = require("ui/experienceOverview/QuickViewGroupDetailsView"),
        UserSharingPermissionsView     = require("ui/experienceOverview/experiencePermissions/UserSharingPermissionsView"),
        MsSharedEntityModel            = require("ui/experienceOverview/experiencePermissions/MsSharedEntityModel"),
        SharedEntityType               = require("ui/experienceOverview/experiencePermissions/SharedEntityType"),
        QuickViewConstants             = require("ui/experienceOverview/QuickViewConstants"),
        template                       = require("ui/experienceOverview/QuickView.tpl");

    /**
     * The <tt>QuickView</tt> is used to display experience details inside a <tt>LightBox</tt>.
     *
     * @cfg {ExperienceModel} model The current <tt>ExperienceModel</tt>.
     *
     * @see LightBox
     *
     * @class QuickView
     */
    return ImprovedView.extend({

        template: template,

        _entries: null,

        _group: null,

        _experienceView: null,

        templateHelpers: function() {
            var projectContext = this.options.projectContext,
                project = this._getProject(),
                isInProject = !_.isUndefined(project),
                projectId = isInProject ? project.get("id") : "",
                projectName = isInProject ? project.get("name") : "",
                projectDashboardUrl = "#/project/" + projectId;

            return {
                spectatorMode:          this.options.spectatorMode,
                isInProject:            isInProject,
                projectContext:         projectContext,
                projectDashboardUrl:    projectDashboardUrl,
                projectName:            projectName,
                isGroup:                !!this._group,
                entries:                this._entries,
                groupType:              this._group && this._group.getDashedType()
            };
        },

        ui: {
            variantTab: ".variant-tab",
            projectLink: ".project-url"
        },

        events: {
            "click @ui.variantTab": function(event) {
                var $target = $(event.currentTarget),
                    experienceId = $target.data("experience"),
                    experienceModel = _.findWhere(this._assets, {id: experienceId});

                if (!$target.hasClass("selected")) {
                    this._showSelectedExperienceByModel(experienceModel);
                    this.ui.variantTab.removeClass("selected");
                    $target.addClass("selected");
                }
            },
            // Let's close the quick view when navigating to the project page.
            "click @ui.projectLink": "close"
        },

        groupBindings: {
            ".edit-group-name": {
                // We need to use updateMethod "html" and escape true, because we are using a tag contenteditable
                observe: "name",
                updateMethod: "html",
                escape: true,
                // The dashboard items will be refreshed only when this field is blurred
                events: ["blur"]
            }
        },

        behaviors: {
            editBehavior: {
                behaviorClass: EditBehavior,
                container: ".editable-group-container",
                viewModel: function() {
                    // Use the breakpoint group model if present...
                    return this._group || this.model;
                },

                editFields: [{
                    input: ".edit-group-name",
                    model: "name",
                    save: function() {
                        if (this._group) {
                            return this._group.saveLater().done(() => {
                                var eventProperties = {
                                    groupId: this._group.get("id"),
                                    groupType: this._group.get("type"),
                                    groupVersion: this._group.get("version"),
                                    groupPushedVersion: this._group.get("pushedVersion"),
                                    projectId: this.options.projectContext && this.options.projectContext.project.get("id"),
                                    triggerOrigin: "EditGroupNameInputField",
                                    quickView: true,
                                    updateProperty: "name",
                                    updatedValue: this._group.get("name")
                                };

                                EditorEvents.trigger(EditorEvents.constants.UPDATE_GROUP, eventProperties);
                            });
                        }
                    }
                }]
            }
        },

        regions: {
            experienceDetailsRegion:    ".experience-details-region",
            groupDetailsRegion:         ".group-details-region",
            sharingArea:                ".sharing-area"
        },

        initialize: function() {
            if (this.options.group) {
                this._group = this.options.group;

                this._assets = this._group.getAssets();
                this._entries = this._group.getUniqueEntries();
            }
        },

        onShow: function() {
            this._showExperienceDetailsView();

            if (this._group) {
                // TODO: Until we handle a real group on the dashboard, this.model is a fake 'master Experience'
                // and hence we need to hook the group-name to the correct model for breakpoint groups.
                this.stickit(this._group, this.groupBindings);
                this.ui.variantTab.first().addClass("selected");
                this._showGroupDetailsView();
            }
            this._initializeDropdownComponent();
        },

        _initializeDropdownComponent() {
            if (LoggedInUserState.get("companySettings").get("userPermissionsEnabled")) {
                const entityId = this._group ? this._group.get("id") : this.model.get("id");
                const companyId = this._group ? this._group.get("companyId") : this.model.get("companyId");
                const entityType =  this._group ? SharedEntityType.GROUP : SharedEntityType.EXPERIENCE;
                const sharedEntity = new MsSharedEntityModel({
                    entityId: entityId,
                    companyId: companyId,
                    entityType: entityType
                });

                this.sharingArea.show(new UserSharingPermissionsView({
                    model: sharedEntity,
                    group: this._group
                }));
            }
        },

        /**
         * @private
         * Returns the project model, if the experience is part of a project. Groups are handled differently in this.
         *
         * @returns {ProjectModel} projectModel - the project model, if the experience is part of a project.
         */
        _getProject: function() {
            var projectsCollection = LoggedInUserState.get("projects");
            // FIXME: localized experiences should act the same as groups - this special case should not be here.
            switch (true) {
                case !!this._group: return projectsCollection.byGroupId(this._group.get("id"));
                default: return projectsCollection.byExperience(this.model);
            }
        },

        _showExperienceDetailsView: function(model) {
            var promise = Promise.resolved();

            if (this._experienceView) {
                promise = this._experienceView.fadeOut();
            }

            promise.done(() => {
                // Wait until the promise is done before creating the _experienceView, otherwise it will not be cleaned
                // up properly if users switch tabs quickly.
                this._experienceView = new QuickViewExperienceDetailsView(_.extend(this.options, {
                    // If given a model, use that. If there are variants, use the first. Otherwise it is a regular Experience, use that.
                    model: model || (this._entries && this._entries[0][0]) || this.model
                }));

                this.experienceDetailsRegion.show(this._experienceView);

                this._experienceView.fadeIn().done(() => {
                    this._experienceView.model.trigger(QuickViewConstants.EventNames.QUICK_VIEW_SHOWN);
                });

                this.listenToOnce(this._experienceView, "closeQuickView", this.close);
            });
        },

        _showGroupDetailsView: function() {
            var view = new QuickViewGroupDetailsView(_.extend(this.options, {
                model: this.model,
                entries: this._entries,
                group: this._group,
                project: this.options.projectContext && this.options.projectContext.project
            }));

            this.groupDetailsRegion.show(view);
        },

        _showSelectedExperienceByModel: function(selectedModel) {
            // Make sure all data is fetched for the selected variant, before showing the preview
            selectedModel.fetchAll().done(this._showExperienceDetailsView.bind(this));
        },

        _viewActive: function() {
            return !this.isClosed;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experienceOverview/QuickView.js